const onlyLetters = /[^a-zA-Z ]/gi;
const onlyNumbers = /[^0-9]*$/g;
const onlyLettersAndNumbers = /[^a-zA-Z0-9]*$/;
const onlyLettersNumbersAndSpaces = /[^a-zA-Z0-9 ]*$/;
const onlyEmail = /[^a-zA-Z0-9._+-@]/gi;
const onlySimpleText = /[^ñÑa-zA-Z0-9. !?()]*$/;
const onlySimpleTextWithAt = /[^ñÑa-zA-Z0-9. /!?()@]*$/;
const onlySimpleTextWithAccents = /[^a-zÀ-ÿA-Z0-9. !?()´]*$/;
const onlySimpleTextWithAccentsAndAt = /[^a-zÀ-ÿA-Z0-9. !?()@´]*$/;

const filterString = (value, regex) => value.replace(regex, '');
const filterInputString = (input, regex) => {
  const value = input.target.value;
  return filterString(value, regex);
};

const filterInputStringUpperCase = (input, regex) => {
  const value = input.target.value.toLocaleUpperCase();
  return filterString(value, regex);
};

const filterInputStringUpperCaseWithOutSpaces = (input, regex) => {
  const value = input.target.value.toLocaleUpperCase();
  const newValue = filterString(value, regex);
  return newValue.replace(/\s/g, '');
};

const daysAbr = ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab'];

const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

const dateToStr = (date) => {
  const days = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ];

  const [day, month, year] = date.split('/').map(Number);
  const fecha = new Date(year, month - 1, day);

  const dayName = days[fecha.getDay()];
  const monthName = months[fecha.getMonth()];

  return `${dayName}, ${day} de ${monthName} de ${year}`;
};

export {
  filterString,
  filterInputString,
  filterInputStringUpperCase,
  filterInputStringUpperCaseWithOutSpaces,
  dateToStr,
  months,
  daysAbr,
  onlyLetters,
  onlyNumbers,
  onlyLettersAndNumbers,
  onlyLettersNumbersAndSpaces,
  onlyEmail,
  onlySimpleText,
  onlySimpleTextWithAt,
  onlySimpleTextWithAccents,
  onlySimpleTextWithAccentsAndAt,
};
